<ng-container *ngIf="!supportFontApi">
    <p *ngFor="let font of fonts" id="{{font.name}}">.</p>
</ng-container>